import React, { useState, useEffect } from "react";
import { Delete } from "lucide-react";
import { useApp } from "@/contexts/AppContext";

export default function PinPad({ value, onChange, onSubmit, maxLen = 4 }) {
    const { t } = useApp();
    const press = (n) => {
        if (value.length < maxLen) {
            const next = value + n;
            onChange(next);
            if (next.length === maxLen) onSubmit?.(next);
        }
    };
    const del = () => onChange(value.slice(0, -1));

    useEffect(() => {
        const onKey = (e) => {
            if (/^[0-9]$/.test(e.key)) press(e.key);
            else if (e.key === "Backspace") del();
            else if (e.key === "Enter" && value.length === maxLen) onSubmit?.(value);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <div className="w-full max-w-sm mx-auto" data-testid="pin-pad">
            <div className="flex justify-center gap-3 mb-8" data-testid="pin-display">
                {Array.from({ length: maxLen }).map((_, i) => (
                    <div
                        key={i}
                        className={`w-4 h-4 rounded-full transition-colors ${i < value.length ? "bg-primary" : "bg-secondary border border-border"}`}
                    />
                ))}
            </div>
            <div className="grid grid-cols-3 gap-3">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                    <button
                        key={n}
                        type="button"
                        className="pin-btn"
                        onClick={() => press(String(n))}
                        data-testid={`pin-btn-${n}`}
                    >
                        {n}
                    </button>
                ))}
                <button
                    type="button"
                    className="pin-btn opacity-50"
                    aria-hidden
                    tabIndex={-1}
                />
                <button
                    type="button"
                    className="pin-btn"
                    onClick={() => press("0")}
                    data-testid="pin-btn-0"
                >
                    0
                </button>
                <button
                    type="button"
                    className="pin-btn"
                    onClick={del}
                    data-testid="pin-btn-del"
                    aria-label="delete"
                >
                    <Delete className="h-7 w-7 mx-auto" />
                </button>
            </div>
        </div>
    );
}
